export default __webpack_public_path__ + "d90d8a0d84c3394173a0d73ef7f85e88.svg";